import React from 'react';
import Icon from '../../../components/AppIcon';

const ControlRoomKPIBar = ({ stats }) => {
  const {
    totalBuildingSqft = 0,
    availableBareshellSqft = 0,
    occupancyPercent = 0,
    occupancyTrend = 'up',
    monthlyRevenue = 0,
  } = stats || {};

  const kpis = [
    {
      label: 'Total Building Size',
      value: `${(totalBuildingSqft / 1000)?.toFixed(1)}K sqft`,
      icon: 'Building2',
      color: 'bg-blue-500',
      sub: 'Total built-up area',
    },
    {
      label: 'Available Bareshell',
      value: `${(availableBareshellSqft / 1000)?.toFixed(1)}K sqft`,
      icon: 'LayoutGrid',
      color: 'bg-purple-500',
      sub: 'Ready to lease',
    },
    {
      label: 'Occupancy Rate',
      value: `${parseFloat(occupancyPercent)?.toFixed(1)}%`,
      icon: occupancyTrend === 'up' ? 'TrendingUp' : 'TrendingDown',
      color: parseFloat(occupancyPercent) >= 70 ? 'bg-green-500' : 'bg-orange-500',
      sub: occupancyTrend === 'up' ? '\u2191 Trending up' : '\u2193 Trending down',
      trendColor: occupancyTrend === 'up' ? 'text-green-600' : 'text-red-600',
    },
    {
      label: 'Monthly Revenue',
      value: `₹${(monthlyRevenue / 100000)?.toFixed(1)}L`,
      icon: 'IndianRupee',
      color: 'bg-emerald-500',
      sub: 'Active agreements',
    },
  ];

  return (
    <div className="grid grid-cols-2 lg:grid-cols-4 gap-4 mb-6">
      {kpis?.map(kpi => (
        <div key={kpi?.label} className="bg-white rounded-xl border border-gray-200 p-4 flex items-center gap-3 shadow-sm">
          <div className={`w-11 h-11 rounded-xl ${kpi?.color} flex items-center justify-center flex-shrink-0`}>
            <Icon name={kpi?.icon} size={20} color="white" />
          </div>
          <div className="min-w-0">
            <p className="text-xs text-gray-500 font-medium truncate">{kpi?.label}</p>
            <p className="text-xl font-bold text-gray-900 leading-tight">{kpi?.value}</p>
            <p className={`text-xs mt-0.5 ${kpi?.trendColor || 'text-gray-400'}`}>{kpi?.sub}</p>
          </div>
        </div>
      ))}
    </div>
  );
};

export default ControlRoomKPIBar;
